/**
 * Browser (window.print) fallback for thermal receipts.
 * - @page size hints Chrome toward 80mm roll / portrait-style layout (not full A4 landscape).
 * - Blob URL avoids an empty "about:blank" address bar.
 */

export const THERMAL_BILL_BROWSER_BASE_CSS = `
        @charset "UTF-8";
        /* Narrow page for 80mm thermal; "auto" height for continuous roll */
        @page {
          size: 80mm auto;
          margin: 0;
        }
        @media screen {
          html { background: #e8e8e8; }
          body {
            max-width: 80mm;
            margin: 12px auto !important;
            padding: 8px !important;
            box-shadow: 0 1px 6px rgba(0,0,0,0.12);
          }
        }
        @media print {
          @page {
            size: 80mm auto;
            margin: 0;
          }
          html, body {
            width: 72mm !important;
            max-width: 72mm !important;
            margin: 0 !important;
            padding: 0 !important;
            background: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .bill-container {
            width: 100% !important;
            max-width: 72mm !important;
            padding: 2mm !important;
            margin: 0 !important;
            box-sizing: border-box !important;
          }
        }
`;

/**
 * @param {string} htmlDocument full HTML string
 * @returns {{ ok: boolean, reason?: string }}
 */
export function openThermalBillPrintWindow(htmlDocument) {
  const blob = new Blob([htmlDocument], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const win = window.open(
    url,
    "qrapid_bill_print",
    "width=420,height=900,scrollbars=yes"
  );

  if (!win) {
    URL.revokeObjectURL(url);
    return { ok: false, reason: "popup_blocked" };
  }

  const cleanup = setInterval(() => {
    if (win.closed) {
      clearInterval(cleanup);
      URL.revokeObjectURL(url);
    }
  }, 800);

  try {
    win.focus();
  } catch {
    /* ignore */
  }

  return { ok: true };
}
